/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserRankScoreWithActions } from '../../models/user-rank-score-with-actions';

export interface UserRankActions$Params {
  userId: number;
}

export function userRankActions(http: HttpClient, rootUrl: string, params: UserRankActions$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRankScoreWithActions>> {
  const rb = new RequestBuilder(rootUrl, userRankActions.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserRankScoreWithActions>;
    })
  );
}

userRankActions.PATH = '/user-rank/{userId}';
